@if (signaalkaarten) {
  <mat-nav-list>
    <h3 class="subheader">Signaalkaarten</h3>
    @for (signaalkaart of signaalkaarten.getSignaalkaarten(); track signaalkaart.getId(); let isLast = $last) {
      <mat-list-item (click)="onSignaalkaartClick(signaalkaart)">
        <span matListItemAvatar [ngClass]="signaalkaart.getIcoon()"></span>
        <div matListItemTitle>{{ signaalkaart.getTitel() }}</div>
        <div matListItemLine class="mat-small">{{ signaalkaart.getCategorie() }}</div>
      </mat-list-item>
      @if (!isLast) {
        <mat-divider></mat-divider>
      }
    }
    @if (signaalkaarten.isEmpty()) {
      <mat-list-item
        class="no-list-item-highlight"
        disableRipple>
        <div matListItemTitle>Geen signaalkaarten gevonden</div>
      </mat-list-item>
    }
  </mat-nav-list>
}
